/* ============================================================
   aed-symbol.js — global text replacer for "Dhs." → "AED"
   Shopify renders prices via shop.money_format ("Dhs. {{amount}}")
   in places our price snippet doesn't cover (cart drawer line
   items, dynamic price updates, etc.). This normalises every
   "Dhs." occurrence to "AED " site-wide.
   ============================================================ */
(function () {
  const REPLACEMENT = 'AED ';

  // Matches Shopify's UAE format prefix: "Dhs. 149.00", "Dhs.149.00", "Dhs 149.00"
  const PATTERN = /Dhs\.?\s?/g;

  function shouldSkip(node) {
    const tag = node.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'INPUT') return true;
    if (node.isContentEditable) return true;
    return false;
  }

  function walk(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      if (!node.nodeValue || !PATTERN.test(node.nodeValue)) return;
      PATTERN.lastIndex = 0;
      const parent = node.parentNode;
      if (!parent || shouldSkip(parent)) return;
      node.nodeValue = node.nodeValue.replace(PATTERN, REPLACEMENT);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (shouldSkip(node)) return;
    const kids = Array.from(node.childNodes);
    kids.forEach(walk);
  }

  function sweep() { walk(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  // Re-sweep when DOM changes (cart drawer refresh, filter response, etc.)
  let rafId = null;
  const observer = new MutationObserver((mutations) => {
    let dirty = false;
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) { dirty = true; break; }
      if (m.type === 'characterData') { dirty = true; break; }
    }
    if (!dirty) return;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => { rafId = null; sweep(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
